var map = {
	"./1/1.js": "ef82",
	"./1/2.js": "9927",
	"./2/4.js": "aefe",
	"./2/5.js": "94f1",
	"./ARC-2020/ARC-2020-patient-survey.js": "bd9f",
	"./PWC-2020/AZ-PWC-2020-patient-profile.js": "f23e",
	"./mcrpc/practice_profile.js": "cb68",
	"./mcrpc/practice_profile_v0.js": "7bd6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7a76";